import {LOGIN} from 'Constants/ActionTypes';

const initialState = {
  refreshTokenInfo: {},
  permissionsList: []
};

// 抽象数据结构,并对数据进行处理的地方
const login = (state = initialState, action) => {
  switch (action.type) {
    case `${LOGIN.REFRESH_ACCESS_TOKEN}_SUCCESS`:
      return {
        ...state,
        refreshTokenInfo: action.res.data,
      };
    case `${LOGIN.BUTTON_PERMISSIONS}_SUCCESS`:
      return {
        ...state,
        permissionsList: action.payload.data || [],
      };  
    default:
      return state;
  }
};

export default login;
